(function() {

	$(document).ready(() => {
		$('.project-tabs a').on('click', tabClicked);

		$('.project-gallery').flickity({
			imagesLoaded: true,
			cellAlign: 'center',
			prevNextButtons: true,
			pageDots: false,
			wrapAround: true
		});
	});

	function tabClicked(event) {
		event.preventDefault();

		$(this)
			.addClass('active')
			.siblings()
			.removeClass('active');

		const target = $(this).attr('data-target');
		$('[data-tab]')
			.removeClass('active-tab')
			.filter(`[data-tab="${target}"]`)
			.addClass('active-tab');
	}

})();